<template>
    <div class="content-check-component">
        <div class="title-block">
            <div class="mb-2">
                <label class="page-label">Проверка контента</label>
            </div>
        </div>

        <div class="content-check-component-ctrls mb-4">
            <div style="flex: 1.5; min-width: 320px;" class="content-check-component-ctrls__element">
                <div class="form-label">Выбор аптеки</div>
                <v-select class="searchable"
                          label="street"
                          v-model="store"
                          :options="stores"
                          :reduce="street => street.id"
                          :deselectFromDropdown="false"
                          :clearable="false">
                    <template #no-options="{ search, searching, loading }">
                        <div class="text-not-found">Не найдено</div>
                    </template>
                </v-select>
            </div>

            <div style="flex: 0.7; min-width: 180px;" class="content-check-component-ctrls__element">
                <div class="form-label">Выбор типа устройства</div>
                <v-select class="no-searchable"
                          label="name"
                          v-model="deviceType"
                          :options="deviceTypes"
                          :reduce="name => name.id"
                          :deselectFromDropdown="false"
                          :clearable="false"
                          :searchable="false">
                </v-select>
            </div>

            <div style="flex: 0.35; min-width: 60px;" class="content-check-component-ctrls__element">
                <label for="exampleFormControlInput1" class="form-label">№ ус-ва</label>
                <input type="number" min="1" class="form-control" id="device-item" v-model="deviceItem" placeholder="№">
            </div>

            <button @click="getData" style="align-self: flex-start; margin-top: 28px;" class="btn btn-primary">
                Найти
            </button>

            <div style="align-self: flex-start; margin-top: 22px; min-width: 205px;" class="content-check-component-ctrls__element">
                <!--                <div style="padding-bottom: 0px;" class="form-label">Найдено {{ differences.length }} различий</div>-->
                <div style="padding-left: 28px; margin-bottom: 0px;" class="form-check">
                    <input class="form-check-input" type="checkbox" id="flexCheckDefault" v-model="showDifferencesOnly">
                    <label class="form-check-label" for="flexCheckDefault">
                        Вывести только различия
                    </label>
                </div>
            </div>
        </div>

        <div class="content-block">
            <div class="content-block-preview">
                <div class="content-block-preview__title">
                    <span>План из админки</span>
                    <span>{{ filteredAdminContent.length }}</span>
                </div>

                <div class="content-block-preview__content">
                    <div v-for="element in filteredAdminContent"
                         :key="element.id"
                         class="content-banner">
                        <img class="content-banner__img" :src="element.img">
                        <div class="content-banner__text">
                            <span class="primary-text" :title="element.name">{{ element.name }}</span>
                            <span class="secondary-text" :title="element.playlist">{{ element.playlist }}</span>
                            <span class="secondary-text" :title="element.display_period">{{ element.display_period }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="content-block-preview">
                <div class="content-block-preview__title">
                    <span>Факт из устройства</span>
                    <span>{{ filteredDeviceContent.length }}</span>
                </div>

                <div class="content-block-preview__content">
                    <div v-for="element in filteredDeviceContent"
                         :key="element.id"
                         class="content-banner"
                         :class="{ difference: isDifference(element) }">
                        <img class="content-banner__img" :src="element.img">
                        <div class="content-banner__text">
                            <span class="primary-text" :title="element.name">{{ element.name }}</span>
                            <span class="secondary-text" :title="element.playlist">{{ element.playlist }}</span>
                            <span class="secondary-text" :title="element.display_period">{{ element.display_period }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <Alert />
</template>

<script>
import Alert from '../../alerts/Alert.vue';
import { mapMutations } from 'vuex/dist/vuex.cjs.js';

export default {
    name: "ContentCheckComponent",
    components: { Alert },
    props: {
        route_get_names_devices_types: String,
        route_get_data_admin_panel: String,
        route_get_data_from_device: String
    },

    data() {
        return {
            store: '',
            deviceType: '',
            deviceTypes: [],
            deviceItem: null,
            storeDeviceData: [],
            stores: [
                {
                    id: null,
                    street: null
                }
            ],
            adminContent: [],

            deviceContent: [],

            showDifferencesOnly: false,
        };
    },

    methods: {
        ...mapMutations('alerts', ['addAlert']),
        getPharmacyes: async function () {
            let resp = await axios.get('/organizational/addresses/get/pharmacyes', {
                params: {
                    limit: 2000
                }})
                .catch(_ => {
                    alert('Не удалось получить список аптек, что то пошло не так');
                });

            if (resp.data.status === 'ok') {
                for (let i = 0; i < resp.data.items.length; i++) {
                    this.stores[i] = {
                        id: resp.data.items[i].id,
                        street: resp.data.items[i].number + ', ' + resp.data.items[i].street
                    }
                }
            }
        },
        getDevicesTypesName: async function () {
            let data = await axios.get(this.route_get_names_devices_types);
            let deviceTypesData = data.data;

            for (const key in deviceTypesData) {
                this.deviceTypes[key] = {
                    id: deviceTypesData[key].id,
                    name: deviceTypesData[key].name
                }
            }
        },
        getData: async function() {
            if (this.store === '' || this.store === null || !Number.isInteger(this.store)) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Выберете аптеку!' });
                return;
            }

            if (this.deviceType === '' || this.deviceType === null) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Выберите тип устройства!' });
                return;
            }

            if (this.deviceItem === null) {
                this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Укажите порядковый номер устройства!' });
                return;
            }

            let dataAdminPanel = await axios.get(this.route_get_data_admin_panel, {
                params: {
                    storeId: this.store,
                    deviceTypeId: this.deviceType,
                    deviceItem: this.deviceItem
                }
            });
            this.dataAdminPanel = dataAdminPanel.data;
            if (this.dataAdminPanel.status == 'ok') {
                if (this.dataAdminPanel.message == 'device_not_found') {
                    this.addAlert({ type: 'error', title: 'Ошибка', text: 'Нет устройства выбранного типа в выбранной аптеке' });
                    this.adminContent = [];
                    this.deviceContent = [];
                    return;
                }
                if (this.dataAdminPanel.message == 'playlists_not_found') {
                    this.addAlert({ type: 'error', title: 'Ошибка', text: 'Нет контента для выбранного устройства' });
                    this.adminContent = [];
                    return;
                }
            }
            this.adminContent = this.dataAdminPanel;



            let dataFromDevice = await axios.get(this.route_get_data_from_device, {
                params: {
                    storeId: this.store,
                    deviceTypeId: this.deviceType,
                    deviceItem: this.deviceItem
                }
            });
            this.dataFromDevice = dataFromDevice.data;
            if (this.dataFromDevice.status == 'ok') {
                if (this.dataFromDevice.message == 'device_content_not_found') {
                    this.addAlert({ type: 'error', title: 'Ошибка', text: 'На выбранном устройстве нет загруженного контента' });
                    this.deviceContent = [];
                    return;
                }
            }
            this.deviceContent = this.dataFromDevice;
        },

        isDifference(element) {
            return this.differences.some(diff => diff.id === element.id);
        },
    },

    computed: {
        differences() {
            return this.adminContent.filter(adminItem => {
                return !this.deviceContent.some(deviceItem =>
                    deviceItem.id === adminItem.id &&
                    deviceItem.name === adminItem.name &&
                    deviceItem.playlist === adminItem.playlist &&
                    deviceItem.display_period === adminItem.display_period
                );
            });
        },

        filteredAdminContent() {
            return this.showDifferencesOnly ? this.differences : this.adminContent;
        },

        filteredDeviceContent() {
            if (!this.showDifferencesOnly) return this.deviceContent;
            let differenceIds = this.differences.map(item => item.id);
            return this.deviceContent.filter(deviceItem => differenceIds.includes(deviceItem.id));
        }
    },
    mounted() {
        this.getPharmacyes();
        this.getDevicesTypesName();
    }
}
</script>

<style scoped lang="scss">
.content-check-component-ctrls {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    &__element {
        display: flex;
        flex-direction: column;
        flex: 1;
    }
}

.btn-primary {
    width: 150px;
    height: 40px;
    align-self: flex-end;
    margin: 0px 0px 1px 0px;
}

.content-block {
    display: flex;
    justify-content: space-between;
    gap: 18px;
    .content-block-preview {
        flex: 1;
        &__title {
            display: flex;
            justify-content: space-between;
            border-top-left-radius: 5px;
            border-top-right-radius: 5px;
            background-color: #F1F6FF;
            span {
                padding: 8px 12px;
                font-size: 16px;
                font-weight: 550;
                color: #575F6E;
            }
        }
        &__content {
            max-height: 597px;
            overflow-y: auto;
            display: flex;
            flex-wrap: wrap;
            .difference {
                background-color: #FBE7E9;
            }
            .content-banner {
                padding: 8px 10px;
                display: flex;
                gap: 12px;
                border-bottom: 1px solid #EAEEF4;
                &__img {
                    width: 95px;
                    height: 64px;
                    border-radius: 7px;
                }
                &__text {
                    display: flex;
                    flex-direction: column;
                    .primary-text {
                        max-width: 137px;
                        font-size: 14px;
                        font-weight: 400;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                    .secondary-text {
                        @extend .primary-text;
                        font-size: 12px;
                        color: #575F6E;
                    }
                }
            }
        }
    }
}
</style>